import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { fetchStoreLocatorPageData } from 'shared/store/store-locator'
import { useDispatch, useSelector } from 'react-redux'
import { media } from 'app/assets/styles'
import type { RootState } from 'shared/store/reducers'
import { RestaurantCardMobile } from 'app/store-locator/restaurant'
import classNames from 'classnames'
import { colors } from 'shared/assets/styles'
import { CURRENT_MAP_VIEW, MapWoosmap } from 'app-v2/modules/geolocation'
import { SPACING } from 'app-v2/design-tokens'

const { shadowBox } = colors

const MapView = () => {
    const dispatch = useDispatch()
    const { activeRestaurant, userPosition, geocodedAddress } = useSelector(
        (state: RootState) => state.storeLocatorPageState
    )
    const [
        restaurantDetailsCollapsed,
        setRestaurantDetailsCollapsed
    ] = useState(true)
    const restaurantCardClasses = classNames({
        collapsed: restaurantDetailsCollapsed
    })

    useEffect(() => {
        dispatch(fetchStoreLocatorPageData())
    }, [])

    return (
        <div>
            <MapWoosmap
                ContainerMap={MapContainer}
                onSelectRestaurant={() => setRestaurantDetailsCollapsed(true)}
                onDeselectRestaurant={() =>
                    setRestaurantDetailsCollapsed(false)
                }
                currentView={CURRENT_MAP_VIEW.CLICK_AND_COLLECT}
            />
            {activeRestaurant && restaurantDetailsCollapsed && (
                <RestaurantCardContainer className={restaurantCardClasses}>
                    <RestaurantCardMobile
                        restaurant={activeRestaurant}
                        collapsed={restaurantDetailsCollapsed}
                        handleToggle={() =>
                            setRestaurantDetailsCollapsed(
                                !restaurantDetailsCollapsed
                            )
                        }
                        origin={geocodedAddress || userPosition}
                        clickAndCollect
                    />
                </RestaurantCardContainer>
            )}
        </div>
    )
}

const MapContainer = styled.div`
    height: 72vh;
    width: 100vw;
    bottom: 0;
    left: 0;
    margin-top: ${SPACING.S};
    ${media.medium`
        position: absolute;
        height: 65vh;
        margin-left: 0;
    `};
`

const RestaurantCardContainer = styled.div`
    position: fixed;
    bottom: 0;
    background: white;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 8px 16px 4px ${shadowBox};
    z-index: 100;
    width: 100%;
    margin-left: 0;
    left: 50%;
    transform: translate(-50%, 0);
    ${media.medium`
        width: calc(100vw - 80px);
        max-width: 1280px;
        margin-left: 0;
    `}
`

export { MapView }
